// extracted by mini-css-extract-plugin
module.exports = {"purpleList":"style-module__purpleList___1-EGh","alignOnNonMobile":"style-module__alignOnNonMobile___3DUga"};